export default __webpack_public_path__ + "static/media/tinkercad-export.639fdb22.png";